import {
  OrderDirection,
  commonMutationTypes,
} from "../../../../../../utils/commonQueryTypes";

export enum PredefinedDataOrderField {
  CREATED_AT = "CREATED_AT",
  TYPE = "TYPE",
  VALUE1 = "VALUE1",
  VALUE2 = "VALUE2",
  VALUE3 = "VALUE3",
  VALUE4 = "VALUE4",
}

export interface PredefinedDataOrder {
  direction: OrderDirection;
  field: PredefinedDataOrderField;
}

export interface PredefinedDataByTypeVars {
  token?: string;
  type: string;
  after: string | null;
  first: number;
  orderBy: PredefinedDataOrder;
  name: string;
}

export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: String;
  endCursor: string;
}

export interface PredefinedData {
  id: string;
}

export interface PredefinedDataEdge {
  node: PredefinedData;
  cursor: string;
}

export interface GetPredefinedDataByType {
  edges: PredefinedDataEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface PredefinedDataByTypeData {
  GetPredefinedDataByType: GetPredefinedDataByType;
}

export interface SettingsTitleProps {
  List: string;
  Registration: string;
  Update: string;
}

export interface PredefinedDataInput {
  [key: string]: string | number;
  type: string;
  id: number;
  indexno: number;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

export interface ConfigDataType {
  LabelName: string;
  inputName: string;
  dataType?: string;
}

export interface CreatePredefinedDataInput {
  type: string;
  index: number;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}
export interface AddPredefinedDataVal extends commonMutationTypes {
  input: CreatePredefinedDataInput;
}

export interface PredefinedData {
  id: string;
  type: string;
  index: number;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

export interface AddPredefinedDataResult {
  PredefinedData: PredefinedData;
}

export interface UpdatePredefinedDataByIdResult {
  id: string;
  type: string;
  index: number;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

export interface UpdatePredefinedDataInput {
  type: string;
  index: number;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

export interface UpdatePredefinedDataByIdVar extends commonMutationTypes {
  id: string;
  input: UpdatePredefinedDataInput;
}

export interface DeletePredefinedDataByIdResult {
  DeletePredefinedDataByIdResult: boolean;
}

export interface DeletePredefinedDataByIdVar extends commonMutationTypes {
  id: string;
}
